import React, { useState, useEffect } from "react";
import { Collapse } from "react-collapse";
import { Link } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import "../styles.css";
import {
  materialesVehiculo,
  materialesMaquinaria,
  materialesUtillaje,
  listarArchivosEquipo,
  subirArchivoEquipo,
  eliminarArchivoEquipo,
  subirImagenPrincipal,
  API_BASE,
  getFileUrl,
} from "../api";
import { toast } from "react-toastify";
import { useConfirm } from "../ConfirmContext";



function EquipoCard({ equipo, tipo, onEditar, onEliminar, mostrarITV, onRefresh }) {
  const [expandido, setExpandido] = useState(false);
  const [materiales, setMateriales] = useState([]);
  const [cargandoMat, setCargandoMat] = useState(false);
  const [errorMat, setErrorMat] = useState(null);
  const [archivos, setArchivos] = useState([]);
  const [subiendo, setSubiendo] = useState(false);
  const [subiendoImagen, setSubiendoImagen] = useState(false);
  const [kmActual, setKmActual] = useState("—");
  const [kmUltimoMantenimiento, setKmUltimoMantenimiento] = useState("—");
  const confirm = useConfirm();
  
  const [imagenLocal, setImagenLocal] = useState(equipo.imagen || null);

  const handleClick = () => setExpandido(!expandido);

  useEffect(() => {
    if (tipo === "vehiculo") {
      setKmActual(equipo.km_actual && equipo.km_actual !== 0 ? equipo.km_actual : "—");
      setKmUltimoMantenimiento(
        equipo.km_ultimo_mantenimiento && equipo.km_ultimo_mantenimiento !== 0
          ? equipo.km_ultimo_mantenimiento
          : "—"
      );
    } else if (tipo === "maquinaria" || tipo === "utillaje") {
      setKmActual(equipo.horas_actuales && equipo.horas_actuales !== 0 ? equipo.horas_actuales : "—");
      setKmUltimoMantenimiento(
        equipo.horas_ultimo_mantenimiento && equipo.horas_ultimo_mantenimiento !== 0
          ? equipo.horas_ultimo_mantenimiento
          : "—"
      );
    }
  }, [equipo, tipo]);

  useEffect(() => {
    setImagenLocal(equipo.imagen || null);
  }, [equipo.imagen]);

  useEffect(() => {
    if (!expandido) return;

    async function fetchMateriales() {
      setCargandoMat(true);
      setErrorMat(null);
      try {
        let data = [];
        if (tipo === "vehiculo") data = await materialesVehiculo(equipo.id);
        else if (tipo === "maquinaria") data = await materialesMaquinaria(equipo.id);
        else if (tipo === "utillaje") data = await materialesUtillaje(equipo.id);
        setMateriales(data);
      } catch (err) {
        console.error("Error cargando materiales:", err);
        setErrorMat("No se pudieron cargar los materiales.");
      } finally {
        setCargandoMat(false);
      }
    }

    fetchMateriales();
  }, [expandido, tipo, equipo.id]);

  useEffect(() => {
    if (!expandido || tipo === "almacen") return;

    async function fetchArchivos() {
      try {
        const data = await listarArchivosEquipo(tipo, equipo.id);
        setArchivos(data);
      } catch (err) {
        console.error("Error cargando archivos:", err);
      }
    }

    fetchArchivos();
  }, [expandido, tipo, equipo.id]);

  const handleSubirArchivo = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      setSubiendo(true);
      await subirArchivoEquipo(tipo, equipo.id, file);
      const nuevos = await listarArchivosEquipo(tipo, equipo.id);
      setArchivos(nuevos);
    } catch (err) {
      toast.error("Error subiendo archivo: " + err.message);
    } finally {
      setSubiendo(false);
      e.target.value = null;
    }
  };

  const handleSubirImagenPrincipal = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      setSubiendoImagen(true);
      const respuesta = await subirImagenPrincipal(tipo, equipo.id, file);
      if (respuesta && respuesta.imagen) {
          setImagenLocal(respuesta.imagen); 
      }
      toast.success("Imagen principal actualizada");
      onRefresh?.();
    } catch (err) {
      console.error("Error subiendo imagen principal:", err);
      toast.error("Error subiendo imagen: " + err.message);
      setImagenLocal(equipo.imagen || null);
    } finally {
      setSubiendoImagen(false);
      e.target.value = null;
    }
  };

  const handleEliminarArchivo = async (id) => {
    const isConfirmed = await confirm({
      title: "¿Eliminar archivo?",
      message: "¿Estás seguro de que deseas eliminar este archivo del equipo?",
    });
    if (!isConfirmed) return;
    try {
      await eliminarArchivoEquipo(tipo, id);
      const nuevos = await listarArchivosEquipo(tipo, equipo.id);
      setArchivos(nuevos);
      toast.success("Archivo eliminado");
    } catch (err) {
      toast.error("Error eliminando archivo: " + err.message);
    }
  };

  const handleEliminarClick = async (e) => {
    e.stopPropagation();
    const isConfirmed = await confirm({
      title: `¿Eliminar ${tipo}?`,
      message: `¿Estás seguro de que deseas eliminar este ${tipo}? Esta acción no se puede deshacer.`,
    });
    if (isConfirmed) {
      onEliminar?.(equipo.id);
    }
  };



  const nombre = equipo.nombre || "—";
  const tipoEquipo = equipo.tipo || "—";
  const referencia = equipo.referencia_interna || equipo.referencia || "—";
  const matriculaOSN =
    tipo === "almacen" ? equipo.referencia || "—" : equipo.matricula || "—";

  const fechaITV =
    (tipo === "vehiculo" || tipo === "maquinaria") && equipo.itv_fecha
      ? new Date(equipo.itv_fecha).toLocaleDateString("es-ES")
      : null;

  const fechaProximaITV =
    (tipo === "vehiculo" || tipo === "maquinaria") && equipo.fecha_proxima_itv
      ? new Date(equipo.fecha_proxima_itv).toLocaleDateString("es-ES")
      : null;

  const claseGrid = tipo === "almacen" ? "grid-almacen" : "";

  return (
    <div className="mantenimiento-card">
      <div 
        className={`fila-item ${claseGrid}`} 
        onClick={handleClick}
      >
        <div className="col-titulo">
          {nombre}
          {referencia !== "—" && tipo !== "almacen" && (
            <Link 
              to={`/${referencia}`} 
              className="link-detalle" 
              onClick={(e) => e.stopPropagation()}
              title="Ver ficha completa"
            >
              <FiExternalLink />
            </Link>
          )}
        </div>

        
        {tipo === "almacen" ? (
          <>
            <div className="col-matricula">{matriculaOSN}</div>
            
            <div className="col-tipo">
              {equipo.cantidad}
            </div>
            
            <div className="col-acciones">
              <button
                className="botonEditar"
                onClick={(e) => {
                  e.stopPropagation();
                  onEditar?.(equipo);
                }}
              >
                Editar
              </button>
              <button className="botonEliminar" onClick={handleEliminarClick}>
                Eliminar
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="col-matricula">{matriculaOSN}</div>
            <div className="col-referencia">{referencia}</div>
            <div className="col-tipo">{tipoEquipo}</div>
          </>
        )}

        {tipo !== "almacen" && (
            <>
                {(mostrarITV || tipo === "vehiculo" || tipo === "maquinaria") && (
                <div className="col-fecha">{fechaProximaITV || "—"}</div>
                )}

                <div className="col-acciones">
                <button
                    className="botonEditar"
                    onClick={(e) => {
                    e.stopPropagation();
                    onEditar?.(equipo);
                    }}
                >
                    Editar
                </button>
                <button className="botonEliminar" onClick={handleEliminarClick}>
                    Eliminar
                </button>
                </div>
            </>
        )}
      </div>

      <Collapse isOpened={expandido}>
        <div className="detalle-mantenimiento expandido">
          <div className="detalle-contenido">
            <div className="detalle-info">
              <p><b>Nombre:</b> {nombre}</p>
              {tipo !== "almacen" && <p><b>Matrícula / SN:</b> {matriculaOSN}</p>}
              <p><b>Referencia:</b> {referencia}</p>
              {tipo !== "almacen" && <p><b>Tipo:</b> {tipoEquipo}</p>}
              {(tipo === "vehiculo" || tipo === "maquinaria" || tipo === "utillaje") &&
                (kmActual !== "—" || kmUltimoMantenimiento !== "—") && (
                  <p>
                    <b>{tipo === "vehiculo" ? "Km actuales" : "Horas actuales"}:</b>{" "}
                    {kmActual} | <b>Último mantenimiento:</b> {kmUltimoMantenimiento}
                  </p>
                )}
              {(tipo === "vehiculo" || tipo === "maquinaria") && (fechaITV || fechaProximaITV) && (
                <p>
                  <b>Última ITV:</b> {fechaITV || "—"} |{" "}
                  <b>Próxima ITV:</b> {fechaProximaITV || "—"}
                </p>
              )}
              {equipo.observaciones && (
                <p><b>Observaciones:</b> {equipo.observaciones}</p>
              )}
              {(tipo === "vehiculo" || tipo === "maquinaria" || tipo === "utillaje") && (
                <div className="detalle-materiales">
                  <b>Materiales compatibles:</b>
                  {cargandoMat ? (
                    <p>Cargando materiales...</p>
                  ) : errorMat ? (
                    <p style={{ color: "red" }}>{errorMat}</p>
                  ) : materiales.length > 0 ? (
                    <ul>
                      {materiales.map((mat) => (
                        <li key={`mat-${mat.id}`}>
                          {mat.nombre} — Ref: {mat.referencia} — Stock: {mat.cantidad}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>— No hay materiales compatibles registrados —</p>
                  )}
                </div>
              )}
            </div>

            {(tipo === "vehiculo" ||
              tipo === "maquinaria" ||
              tipo === "utillaje") && (
              <div className="detalle-archivos">
                <b>Archivos adjuntos:</b>
                <div className="input-archivo">
                  <button
                    className="botonAzul"
                    onClick={() =>
                      document.getElementById(`file-input-${equipo.id}`).click()
                    }
                    disabled={subiendo}
                  >
                    {subiendo ? "Subiendo..." : "Seleccionar archivo"}
                  </button>
                  <input
                    id={`file-input-${equipo.id}`}
                    type="file"
                    onChange={handleSubirArchivo}
                    style={{ display: "none" }}
                  />
                </div>
                {archivos.length > 0 ? (
                  <ul className="lista-archivos">
                    {archivos.map((f) => (
                      <li key={f.id} className="archivo-item">
                        <a 
                          href={getFileUrl(f.ruta)} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          download
                        >
                          {f.nombre}
                        </a>

                        <button
                          className="botonEliminar"
                          onClick={() => handleEliminarArchivo(f.id)}
                        >
                          Eliminar
                        </button>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="sin-archivos">— No hay archivos adjuntos —</p>
                )}
              </div>
            )}

            {(tipo === "vehiculo" ||
              tipo === "maquinaria" ||
              tipo === "utillaje") && (
              <div className="detalle-imagen-equipo">
                <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", marginBottom: "0.5rem" }}>
                  <b>Imagen:</b>
                  <button
                    className="botonAzul"
                    onClick={() =>
                      document.getElementById(`imagen-input-${equipo.id}`).click()
                    }
                    disabled={subiendoImagen}
                    style={{ fontSize: "0.8em", padding: "0.2rem 0.5rem" }}
                  >
                    {subiendoImagen ? "⏳ Subiendo..." : "📁 Subir"}
                  </button>
                  <input
                    id={`imagen-input-${equipo.id}`}
                    type="file"
                    accept="image/*"
                    onChange={handleSubirImagenPrincipal}
                    style={{ display: "none" }}
                  />
                </div>
                {subiendoImagen ? (
                  <div style={{ padding: "2rem", textAlign: "center" }}>
                    Subiendo imagen...
                  </div>
                ) : imagenLocal ? (
                  <div className="contenedor-imagen-equipo">
                    <img
                      src={getFileUrl(imagenLocal)}
                      alt={equipo.nombre || "Imagen equipo"}

                      className="imagen-equipo"
                      onError={(e) => {
                          console.log("Error cargando imagen con timestamp, reintentando...");
                          e.target.style.display = 'none'; 
                      }}
                    />
                  </div>
                ) : (
                  <p className="sin-archivos">— Sin imagen —</p>
                )}
              </div>
            )}
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default EquipoCard;
